import React from 'react';
import { DynamicFormBuilderContainer } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { MuiStack } from '../../../../components';
import { Chip, Typography } from '@mui/material';
export var HistoryElements = [{
        type: FormItemTypes.ContainerItem,
        name: '',
        padding: '10px',
        rowSpacing: 0,
        // columnSpacing: 2,
        m: 2,
        borderRadius: '8px',
        columnSize: 12,
        bgcolor: 'secondary.50',
        elements: [{
                type: FormItemTypes.Typography,
                name: '',
                label: 'User :',
                value: 'Kunal Sharma',
                columnSize: 12,
                containerProps: {
                    container: true,
                    justifyContent: 'space-between',
                    alignItems: 'center'
                },
                labelTypographyProps: {
                    fontSize: 'base',
                    color: '#6A7682',
                    mb: 0
                }
            }, {
                type: FormItemTypes.Typography,
                name: '',
                label: 'Department :',
                value: 'Dealer',
                columnSize: 12,
                containerProps: {
                    container: true,
                    justifyContent: 'space-between',
                    alignItems: 'center'
                },
                labelTypographyProps: {
                    fontSize: 'base',
                    color: '#6A7682'
                }
            }, {
                type: FormItemTypes.Typography,
                name: '',
                label: 'Ageing days :',
                value: '0',
                columnSize: 12,
                containerProps: {
                    container: true,
                    justifyContent: 'space-between',
                    alignItems: 'center'
                },
                labelTypographyProps: {
                    fontSize: 'base',
                    color: '#6A7682'
                }
            }, {
                type: FormItemTypes.Typography,
                name: '',
                label: 'Remark :',
                value: 'A little about the company...',
                columnSize: 12,
                containerProps: {
                    container: true,
                    justifyContent: 'space-between',
                    alignItems: 'center'
                },
                labelTypographyProps: {
                    fontSize: 'base',
                    color: '#6A7682'
                }
            }]
    }];
var CQAReceivedEditHistoryListViewMobile = function () {
    var formData = [{
            type: FormItemTypes.Accordian,
            name: 'part',
            label: '',
            value: null,
            sx: {
                p: 1.5
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    label: '',
                    value: null,
                    children: 'History',
                    columnSize: 0,
                    fontWeight: 'strong',
                    fontSize: 'lg'
                }, {
                    type: FormItemTypes.Custom,
                    name: 'count',
                    label: '',
                    value: null,
                    element: function () { /*#__PURE__*/ return React.createElement(MuiStack, {
                        sx: {
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: '100%',
                            marginLeft: '8px'
                        },
                        height: '22px',
                        width: '22px',
                        border: '1.5px solid',
                        borderColor: 'primary.500'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        color: 'primary.500'
                    }, 3)); }
                }],
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Divider,
                            name: 'name',
                            variant: 'fullWidth',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.List,
                            name: '',
                            disableCheckboxSelection: true,
                            columnSize: 12,
                            value: [{
                                    id: 0,
                                    Date: '21 Aug, 2002 • 11:40 AM',
                                    Status: 'Submitted to ASM'
                                }, {
                                    id: 1,
                                    Date: '14 Jul, 2005 • 11:40 AM',
                                    Status: 'Submitted to ASM'
                                }, {
                                    id: 2,
                                    Date: '20 Aug, 1978 • 11:40 AM',
                                    Status: 'Submitted to ASM'
                                }],
                            containerProps: {
                                sx: {
                                    mb: '16px'
                                }
                            },
                            columns: [{
                                    field: 'Part',
                                    flex: 1,
                                    minWidth: 120,
                                    renderCell: function (_ref) {
                                        var row = _ref.row;
                                        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                            fontSize: "base",
                                            fontWeight: "strong",
                                            sx: {
                                                paddingRight: '10px'
                                            }
                                        }, row.Date));
                                    }
                                }, {
                                    field: 'Part1',
                                    flex: 1,
                                    minWidth: 10,
                                    renderCell: function (_ref2) {
                                        var row = _ref2.row;
                                        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Chip, {
                                            label: 'Submitted to ASM',
                                            size: "small",
                                            color: "info",
                                            shape: "rounded"
                                        }));
                                    }
                                }],
                            elements: HistoryElements
                        }]
                }],
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit"
    }));
};
export default CQAReceivedEditHistoryListViewMobile;
